import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import LibrariesList from "./LibrariesList";
import LibraryDetailPage from "./LibraryDetailPage";
import LibraryCreate from "./LibraryCreate";
import LibraryEdit from "./LibraryEdit";
import { RouteGuard } from "../../guards/RouteGuard";
import { LIBRARY_WRITE_ROLES, PV_READ_ROLES } from "../../types/roleSets";
function Libraries() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: PV_READ_ROLES },
                React.createElement(LibrariesList, null))); } }),
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: PV_READ_ROLES },
                React.createElement(LibraryDetailPage, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: LIBRARY_WRITE_ROLES },
                React.createElement(LibraryEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: LIBRARY_WRITE_ROLES },
                React.createElement(LibraryCreate, null))); } })));
}
export default Libraries;
